export default __webpack_public_path__ + "static/media/tutorialImage.dd9e4477.png";